// @flow

import React from 'react';
import styled, { withTheme } from 'styled-components';
import Link from '../link';
import { Flex } from '../grid';
import type { Theme } from '../../types';

const AnchorIcon = styled<typeof Link, Theme>(Link)`
  border: 1px solid ${props => props.theme.contactOption.icon.borderColor};
  border-radius: 50%;
  flex-grow: 0;
  flex-shrink: 0;
  height: ${props => props.theme.contactOption.icon.size};
  width: ${props => props.theme.contactOption.icon.size};
  padding: ${props => props.theme.contactOption.icon.padding};
  color: ${props => props.theme.contactOption.icon.iconColor};
  text-decoration: none;
`;

const Icon = styled<any, Theme>('i')`
  font-size: 1.2rem;
  &:before {
    vertical-align: text-top;
  }
`;

const AnchorText = styled<typeof Link, Theme>(Link)`
  color: ${props => props.theme.contactOption.text.color};
  font-size: ${props => props.theme.contactOption.text.fontSize};
  text-decoration: none;
`;

const SubText = styled<any, Theme>('div')`
  color: ${props => props.theme.contactOption.subtitle.color};
  font-size: ${props => props.theme.contactOption.subtitle.fontSize};
`;

type OwnProps = {|
  className?: ?string,
  icon: string,
  link: string,
  theme: Object,
  title: string,
  subtitle: string,
|};

type Props = OwnProps;

const ContactOption = ({
  className,
  icon,
  link,
  title,
  subtitle,
}: Props) => (
  <section className={className}>
    <Flex>
      <AnchorIcon href={link}>
        <Icon className={`icon-${icon}`} />
      </AnchorIcon>
      <Flex
        flexDirection="column"
        justifyContent="center"
        ml="1.25rem"
      >
        <AnchorText href={link}>{title}</AnchorText>
        <SubText>{subtitle}</SubText>
      </Flex>
    </Flex>
  </section>
);

ContactOption.defaultProps = {
  className: '',
};

export default withTheme(ContactOption);
